// extracted by mini-css-extract-plugin
module.exports = {"Alarm":"style_Alarm__1jPYe","ArowControl":"style_ArowControl__YELzj"};